export const deviceTypesAomQuery = () =>
    `query getAllDeviceTypes {
      deviceTypes {
          id
          name
          settings {
            operatorListMode
            supportPermissions
            supportRole
            supportIncrementalOperatorLists
            supportFullOperatorLists
            maximumOperators
          }
      }
    }
  `;

export const deviceTypesAdmQuery = () => `
    query getAllDeviceTypes {
      deviceTypes {
          id
          name
          settings {
            operatorListMode
            supportPermissions
            supportRole
            supportIncrementalOperatorLists
            supportFullOperatorLists
            maximumOperators
          }
          resultTypes {
            id
            name
          }
      }
    }
  `;
